<template>
  <div class="autocomplete">
    <v-autocomplete
      v-model="partner"
      @keyup="search"
      @change="handleSelect"
      @click:clear="clear"
      :no-data-text="$t('partner.noData')"
      :label="$t('host.label.partner')"
      :items="partners"
      prepend-inner-icon="mdi-magnify"
      item-value="id"
      item-text="name"
      return-object
      clearable
      outlined
    />

    <v-progress-circular
      v-show="isPartnersLoading"
      class="autocomplete-loading"
      color="primary"
      width="2"
      size="15"
      indeterminate
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'HPartnerSelect',

  props: {
    defaultValue: {
      default: null,
    },
  },

  watch: {
    defaultValue(value) {
      if (!value) return

      this.setPartners([value])
      this.$nextTick(() => this.partner = value)
    },
  },

  computed: {
    ...mapGetters(['partners']),
  },

  methods: {
    ...mapActions(['fetchPartners']),
    ...mapMutations(['setFilters', 'setPartners']),

    handleSelect(value) {
      if (!value) return
      this.$emit('input', this.partner)
      return
    },

    search({ target }) {
      const term = target?.value
      if (!term && term?.length <= 3) return

      clearTimeout(this.timer)

      this.isPartnersLoading = true
      this.setFilters({ search: term })

      this.timer = setTimeout(() => {
        this.fetchPartners().finally(() => this.isPartnersLoading = false)
      }, 1000)
    },

    clear() {
      this.partner = null
      this.$emit('input', null)
    },
  },

  data() {
    return {
      partner: null,
      isPartnersLoading: false,
      timer: null,
    }
  }
}
</script>

<style scoped>
.autocomplete {
  position: relative;
}

.autocomplete-loading {
  position: absolute;
  top: 28px;
  right: 45px;
  transform: translateY(-50%);
}
</style>
